module.exports = __webpack_public_path__ + "media/images/story/typo/congratsMode-feb3e905a8fcc8e6e1a3f6fe683de6c1.svg";